/**
 * Central config for the "Download Harday App" link on the home screen.
 *
 * Single source of truth for where the app can be downloaded. The URL is a
 * configurable environment variable so it can change without touching any
 * component. Create React App only injects vars prefixed with REACT_APP_, so
 * REACT_APP_APP_DOWNLOAD_URL is the canonical name; the plainer APP_DOWNLOAD_URL
 * is also honoured for build setups that expose it. A sensible production
 * default is used when neither is set.
 */

const readEnv = (...names) => {
  for (const name of names) {
    const value = process.env[name];
    if (value && value.trim()) return value.trim();
  }
  return '';
};

// Direct link to the APK served as a static file (nginx sends it with
// Content-Disposition: attachment), so tapping the button downloads the APK
// immediately — no intermediate page, no /download route.
const DEFAULT_APP_DOWNLOAD_URL = '/downloads/harday.apk';

// Android APK direct download (single-touch download of the APK file).
export const APP_DOWNLOAD_URL =
  readEnv('REACT_APP_APP_DOWNLOAD_URL', 'APP_DOWNLOAD_URL') || DEFAULT_APP_DOWNLOAD_URL;
